import { environment } from 'src/environments/environment';

const PLACEHOLDER = 'assets/Portrait_Placeholder.png';

/** API host without trailing `/api` (e.g. https://api.bidarbak.com). */
export function apiOrigin(): string {
  return String(environment.apiUrl || '').replace(/\/api\/?$/, '');
}

/**
 * Build a browser-cacheable public storage URL.
 * Prefer this over authenticated blob downloads for avatars/car photos.
 */
export function toStorageUrl(path?: string | null): string | null {
  if (path == null) return null;

  let normalized = String(path).replace(/\\/g, '/').trim();
  if (!normalized) return null;
  if (['[]', '{}', 'null', 'undefined', '[object Object]'].includes(normalized)) {
    return null;
  }

  if (
    /^https?:\/\//i.test(normalized) ||
    normalized.startsWith('blob:') ||
    normalized.startsWith('data:') ||
    normalized.startsWith('assets/')
  ) {
    return normalized;
  }

  normalized = normalized
    .replace(/^https?:\/\/[^/]+\/storage\//i, '')
    .replace(/^\/?storage\//i, '')
    .replace(/^\/+/, '');

  if (!normalized) return null;

  return `${apiOrigin()}/storage/${normalized}`;
}

/** Resolve a profile picture for <img [src]>. */
export function profilePictureSrc(
  userOrPath?:
    | string
    | null
    | {
        profile_picture_url?: string | null;
        profile_picture?: string | null;
      },
  fallback: string = PLACEHOLDER,
): string {
  if (!userOrPath) return fallback;

  if (typeof userOrPath === 'string') {
    return toStorageUrl(userOrPath) || fallback;
  }

  return (
    toStorageUrl(userOrPath.profile_picture_url) ||
    toStorageUrl(userOrPath.profile_picture) ||
    fallback
  );
}
